var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavNon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34809 8.53574C7.34809 8.53574 8.54455 6.94435 10.6448 7.61651",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6509 8.53574C16.6509 8.53574 15.4545 6.94435 13.3542 7.61651",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8412 11.8959C10.8412 10.294 9 10.294 9 11.8959C9 13.4979 10.8412 13.4979 10.8412 11.8959Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.8916C15 10.2897 13.1588 10.2897 13.1588 11.8916C13.1588 13.3501 15 13.3501 15 11.8916Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6587 16.5637C14.1066 16.1239 13.3763 15.883 12.5995 15.9293C11.3302 16.0049 10.2561 16.8343 9.9543 17.9711",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52867 3.5492C10.2617 1.09387 13.7388 1.09387 14.4719 3.5492L15.711 7.69967L20.0413 7.5956C22.603 7.53404 23.6774 10.841 21.5688 12.2969L18.0044 14.7579L19.4415 18.8441C20.2916 21.2614 17.4786 23.3052 15.4423 21.7496L12.0003 19.1202L8.55821 21.7496C6.52195 23.3052 3.70891 21.2614 4.55906 18.8441L5.99615 14.7579L2.43174 12.2969C0.32311 10.841 1.3976 7.53404 3.95928 7.5956L8.28952 7.69967L9.52867 3.5492Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavNon);
export default __webpack_public_path__ + "static/media/fav_non.6bb022d0dcd70e1e6fdc92ee59f6c75f.svg";
export { ForwardRef as ReactComponent };